import React from "react";
import {
  Grid,
  Button,
  Typography,
  IconButton,

  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {

} from "@mui/styles";
import {
  CloseRounded as CloseRoundedIcon
} from "@mui/icons-material";

const initState = {
  isOpen: false,
  title: '',
  message: '',
  dangerLabel: '',
  successLabel: '',
  onDanger: null,
  onSuccess: null,
}
class DialogConfirmAction extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
       ...initState
    };
  }

  open = ({ title, message, dangerLabel, successLabel, onSuccess, onDanger }) => {
    this.setState({
      isOpen: true,

      title: title || 'Подтверждение',
      message: message || 'Вы действительно хотите это сделать?',

      dangerLabel: dangerLabel || '',
      successLabel: successLabel || '',

      onDanger,
      onSuccess,
    })
  }
  close = () => {
    this.setState({
      ...initState
    })
  }

  onDanger = () => {
    const _onDanger = this.state.onDanger;
    this.close();
    if (!_onDanger) {return}
    _onDanger();
  }
  onSuccess = () => {
    const _onSuccess = this.state.onSuccess;
    this.close();
    if (!_onSuccess) {return}
    _onSuccess();
  }

  render() {
    const {
      isOpen,
      title,
      message,
      dangerLabel,
      successLabel,
    } = this.state;

    if (!isOpen) {
      return null
    }
    return (
      <Dialog
        open={isOpen}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle>
          <Grid container>
            <Grid item sx={{flex: 1}}>
              { title }
            </Grid>
            <Grid item>
              <IconButton onClick={this.close}>
                <CloseRoundedIcon/>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Typography
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Button
                size="small"
                color="secondary"
                variant="contained"
                onClick={this.onDanger}
              >{dangerLabel || 'Отменить'}</Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={this.onSuccess}
              >{successLabel || 'Подтвердить'}</Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DialogConfirmAction
